import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'

import Actions from '../Actions/Actions'

import { addClass, getErrorFields, getErrorMessages, removeClass } from '../../helpers'
import { translate, Translate } from 'react-i18nify'

import { diffProfileItems, editProfileItem } from '../../store/actions/user'

import Alert from '../Alert/Alert'

let map

class FormReferences extends Component {
    constructor(props) {
        super(props)

        if (this.props.edit != undefined) {
            let ref = this.props.edit

            this.state = {
                id: ref.id,
                company: ref.company,
                name: ref.name,
                phone: ref.phone_number,
                description: ref.description,
                edit: true,
                loading: false,
                errors: [],
                fields: [],
            }
        } else {
            this.state = {
                errors: [],
                fields: [],
                id: -1,
                company: '',
                name: '',
                phone: '',
                description: '',
                error: '',
                edit: false,
                loading: false,
            }
        }
    }

    getClassNames(item) {
        if (item != null && item != '' && item.length > 0) {
            return 'form__input--text has-value'
        } else {
            return 'form__input--text'
        }
    }

    handleChange(value, key, changeClass = true) {
        let obj = {}
        obj[key] = value.target.value

        this.setState(obj)

        if (changeClass) {
            if (value.target.value.length > 0) {
                addClass(value.currentTarget, 'has-value')
            } else {
                removeClass(value.currentTarget, 'has-value')
            }
        }
    }

    save() {
        let company = this.state.company,
            name = this.state.name,
            phone = this.state.phone,
            desc = this.state.description

        //if (company.length < 1 || name.length < 1) {
        //    this.setState({
        //        error: translate('errors.empty_field')
        //    });
        //
        //    return;
        //}

        let ref = {
            company: company,
            name: name,
            phone_number: phone,
            description: desc,
        }

        if (this.state.id != -1) {
            ref.id = this.state.id
        }

        this.setState({
            loading: true,
        })

        if (this.state.edit) {
            this.props.dispatch(
                editProfileItem(
                    'references',
                    ref,
                    this.props.auth,
                    () => this.onSuccess(),
                    (status, error) => this.onError(status, error),
                ),
            )
        } else {
            this.props.dispatch(
                diffProfileItems(
                    'references',
                    [ref],
                    [],
                    this.props.auth,
                    () => {
                        this.onSuccess()
                    },
                    (s, o) => {
                        this.onError(s, o)
                    },
                ),
            )
        }
    }

    onError(status, object) {
        //TODO: translate
        map = {
            company: translate('profile.reference_company'),
            name: translate('profile.reference_name'),
            phone_number: translate('profile.reference_phonenumber'),
            description: translate('profile.reference_description'),
        }

        this.setState(
            {
                errors: [],
                fields: [],
                loading: false,
            },
            () => {
                if (object.hasOwnProperty('errors')) {
                    let messages = getErrorMessages(object.errors, map)
                    let fields = getErrorFields(object.errors)

                    this.addErrors(messages)
                    this.addErrorFields(fields)
                }
            },
        )
    }

    addErrors(errors) {
        this.setState({
            errors: errors,
        })
    }

    addErrorFields(fields) {
        this.setState({
            fields: fields,
        })
    }

    getClassNames(item, field) {
        let c = 'form__input--text'

        if (item != null && item != '' && item.length > 0) {
            c += ' has-value'
        }

        if (this.state.fields.indexOf(field) != -1) {
            c += ' error'
        }

        return c
    }

    onSuccess() {
        this.state = {
            errors: [],
            fields: [],
            id: -1,
            company: '',
            name: '',
            phone: '',
            description: '',
            error: '',
            edit: false,
            loading: false,
        }
        this.props.onSave()
    }

    cancel() {
        this.state = {
            errors: [],
            fields: [],
            id: -1,
            company: '',
            name: '',
            phone: '',
            description: '',
            error: '',
            edit: false,
            loading: false,
        }
        this.props.onCancel()
    }

    getSaveClasses() {
        let c = 'actions__action--save'

        if (this.state.loading) {
            c += ' is-loading'
        }

        return c
    }

    render() {
        const { className } = this.props

        return (
            <form
                className={this.props.className}
                onKeyDown={(e) => {
                    if (e.keyCode === 13) {
                        //Enter pressed
                        this.save()
                    }
                }}
            >
                <fieldset className="form__fieldset">
                    {this.state.errors && this.state.errors.length > 0 && (
                        <Alert type="alert--error alert--simple">
                            <ul>
                                {this.state.errors.map(function (value) {
                                    return <li key={value}>{value}</li>
                                })}
                            </ul>
                        </Alert>
                    )}

                    <div className="form__item">
                        <i className="form__icon icons icon-location-pin" />
                        <input
                            className={this.getClassNames(this.state.company)}
                            value={this.state.company}
                            type="text"
                            id="reference_company"
                            onChange={(value) => this.handleChange(value, 'company')}
                            tabIndex="1"
                            autoFocus
                        />
                        <label className="form__label" htmlFor="reference_company">
                            <Translate value="profile.reference_company" />
                        </label>
                    </div>
                    <div className="form__item">
                        <i className="form__icon icons icon-user" />
                        <input
                            className={this.getClassNames(this.state.name)}
                            value={this.state.name}
                            type="text"
                            id="reference_name"
                            onChange={(value) => this.handleChange(value, 'name')}
                            tabIndex="2"
                        />
                        <label className="form__label" htmlFor="reference_name">
                            <Translate value="profile.reference_name" />
                        </label>
                    </div>
                    <div className="form__item">
                        <i className="form__icon icons icon-phone" />
                        <input
                            className={this.getClassNames(this.state.phone)}
                            value={this.state.phone}
                            type="tel"
                            id="reference_phonenumber"
                            onChange={(value) => this.handleChange(value, 'phone')}
                            tabIndex="3"
                        />
                        <label className="form__label" htmlFor="reference_phonenumber">
                            <Translate value="profile.reference_phonenumber" />
                        </label>
                    </div>

                    <div className="form__item">
                        <i className="form__icon icons icon-notebook" />
                        <input
                            className={this.getClassNames(this.state.description)}
                            value={this.state.description}
                            type="text"
                            id="reference_description"
                            onChange={(value) => this.handleChange(value, 'description')}
                            tabIndex="4"
                        />
                        <label className="form__label" htmlFor="reference_description">
                            <Translate value="profile.reference_description" />
                        </label>
                    </div>
                </fieldset>
                <Actions>
                    <Link
                        className="actions__action--cancel"
                        onClick={() => this.cancel()}
                        tabIndex="5"
                    >
                        <Translate value="profile.cancel" />
                    </Link>
                    <Link
                        className={this.getSaveClasses()}
                        onClick={() => this.save()}
                        tabIndex="6"
                    >
                        <Translate value="profile.save" />
                    </Link>
                </Actions>
            </form>
        )
    }
}

FormReferences.propTypes = {
    className: PropTypes.string.isRequired,
    onCancel: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    dispatch: PropTypes.func.isRequired,
    edit: PropTypes.object,
}

function mapStateToProps(state) {
    const { auth, user } = state

    return {
        auth,
        user,
    }
}

// Wrap the component to inject dispatch and state into it
export default connect(mapStateToProps)(FormReferences)
